import React from "react";
import PropTypes from "prop-types";
import "./PhoneInput.css";

const PhoneInput = props => (
  <div className="phone-input">
    <label className="phone-input-label" htmlFor="phoneNumber">
      Número de teléfono móvil
    </label>
    <div className="phone-input-group">
      <div className="phone-input-country-code">
        {props.countryCode.replace("00", "+")}
      </div>
      <input
        className="phone-input-phone-number"
        id="phoneNumber"
        name="phoneNumber"
        type="tel"
        placeholder="000000000"
        value={props.phoneNumber}
        onChange={props.onChange}
        aria-invalid={props.errors.phoneNumber}
        autoComplete="tel"
      />
    </div>
    {props.errors.phoneNumber && (
      <div className="phone-input-error" aria-live="polite">
        El número de teléfono no es válido
      </div>
    )}
    {props.errors.phoneNumberNotExists && (
      <div className="phone-input-error" aria-live="polite">
        No existe una cuenta con este número de teléfono
      </div>
    )}
  </div>
);

PhoneInput.propTypes = {
  countryCode: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.bool)
};

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/PhoneInput/PhoneInput.js